import React from 'react'
import { useSelector } from 'react-redux'

import { JobDetails } from './JobDetails/JobDetails'
import { JobsListing } from './JobListing/JobsListing'

import { getLocation } from 'ducks/router'

export const Jobs = () => {
  const {
    payload: { id },
  } = useSelector(getLocation)

  if (id) {
    return <JobDetails />
  }

  return <JobsListing />
}
